import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useInView } from "react-intersection-observer";
import Society from "../../images/Society.svg";
import Market from "../../images/Market.svg";
import Environment from "../../images/Environment.svg";
import Workplace from "../../images/Workplace.svg";

const RowCSRdomains = () => {
  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row text-center">
        <div className="stickyRowHeaders3 col-lg-4 col-12 d-flex align-items-center justify-content-center ">
          <div className="d-lg-none d-inline">
            <div>Social Responsibility</div>
            <div>Domains of Digikala</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-30, 30]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Social Responsibility</div>
                <div>Domains of Digikala</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg px-2 px-lg-4 bg-color-w py-2 py-lg-5">
          <div
            ref={refFact1}
            className={
              refFact1isVisible
                ? "fade-in-section is-visible row m-0 text-center py-3 py-lg-5"
                : "fade-in-section row m-0 text-center py-3 py-lg-5"
            }
          >
            <div className="row mx-0 justify-content-center ">
              <div className="col-6 col-lg-3 p-3 ">
                <img className="CSRcoverImages" src={Society} alt="Society" />
                <h6 className="bg-color-gr dk-bold py-4 radius4 dk-medium">
                  Society
                </h6>
                <p className="dk-small pt-3 text-start">
                  • Acting towards social equity and equal access for all
                  Iranian people.
                </p>
                <p className="dk-small pt-3 text-start">
                  • Creating a reliable and transparent method for act of
                  kindness.
                </p>
              </div>
              <div className="col-6 col-lg-3 p-3 ">
                <img className="CSRcoverImages" src={Market} alt="Market" />
                <h6 className="bg-color-gr dk-bold py-4 radius4 dk-medium">
                  Market
                </h6>
                <p className="dk-small pt-3 text-start">
                  • Sustainable Employment
                </p>
                <p className="dk-small pt-3 text-start">
                  • Empowering local societies and facilitating their access to
                  the opportunities of e- commerce market.
                </p>
              </div>
              <div className="col-6 col-lg-3 p-3">
                <img
                  className="CSRcoverImages"
                  src={Environment}
                  alt="Environment"
                />
                <h6 className="bg-color-gr dk-bold py-4 radius4 dk-medium">
                  Environment
                </h6>
                <p className="dk-small pt-3 text-start">
                  • Reducing environmental impacts caused by Digikala operations
                  by delivery route optimization and re- collection of goods.
                </p>
                <p className="dk-small pt-3 text-start">
                  • Reducing fuel consumption.
                </p>
                <p className="dk-small pt-3 text-start">
                  • Returning Digikala cartons.
                </p>
              </div>
              <div className="col-6 col-lg-3 p-3">
                <img
                  className="CSRcoverImages"
                  src={Workplace}
                  alt="Workplace"
                />
                <h6 className="bg-color-gr dk-bold py-4 radius4 dk-medium">
                  Workplace
                </h6>
                <p className="dk-small pt-3 text-start">
                  • Improvement of health status and safety at the workplace
                </p>
                <p className="dk-small pt-3 text-start">
                  • Creating platforms for participating in act of kindness
                  projects.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowCSRdomains;
